import {ThemeVariableType} from '@toolify/client/src/modules/theme/enum/ThemeVariableType'
import {IThemeVariables} from '@toolify/client/src/modules/theme/types/IThemeVariables'

// Zmienne wykresow, kanwy automatyzacji i tablicy, ktore w Fiord Night i Dark sa inna zmienna tego samego
// motywu (komponenty czytaly dotad wprost OnPrimary, ContentDarkest, ContainerLow, ...). Liczone z mapy motywu,
// a nie wpisane literalem: zmiana bazowego tokenu przenosi sie na nie tak jak dotad. light-modern ma wlasne
// pochodne (getLightModernDerivedVariables)
export type FiordNightDerivedVariableType =
  | ThemeVariableType.ChartLabelOnSurfaceColor
  | ThemeVariableType.ChartGridColor
  | ThemeVariableType.AutomationCanvasDefaultModuleColor
  | ThemeVariableType.AutomationCanvasRunInProgressColor
  | ThemeVariableType.WhiteboardStickyNoteFoldShadeColor
  | ThemeVariableType.WhiteboardMarqueeFillColor
  | ThemeVariableType.FilterActiveBackgroundColor
  | ThemeVariableType.FilterActiveBackgroundHoverColor
  | ThemeVariableType.FilterActiveContentColor
  | ThemeVariableType.FilterActiveContentHoverColor

export function getFiordNightDerivedVariables(
  variables: Omit<IThemeVariables, FiordNightDerivedVariableType>,
): Pick<IThemeVariables, FiordNightDerivedVariableType> {
  return {
    // legenda, etykieta nad punktem, wygaszony slupek = OnPrimary; siatka osi = ContentDarkest
    [ThemeVariableType.ChartLabelOnSurfaceColor]: variables[ThemeVariableType.OnPrimaryColor],
    [ThemeVariableType.ChartGridColor]: variables[ThemeVariableType.ContentDarkestColor],
    // modul bez koloru aplikacji = ContainerLow, krok w trakcie = ContainerHigh
    [ThemeVariableType.AutomationCanvasDefaultModuleColor]: variables[ThemeVariableType.ContainerLowColor],
    [ThemeVariableType.AutomationCanvasRunInProgressColor]: variables[ThemeVariableType.ContainerHighColor],
    // rog karteczki = ContentDarkest, marquee = PrimaryContainer
    [ThemeVariableType.WhiteboardStickyNoteFoldShadeColor]: variables[ThemeVariableType.ContentDarkestColor],
    [ThemeVariableType.WhiteboardMarqueeFillColor]: variables[ThemeVariableType.PrimaryContainerColor],
    // plakietki sortowania i filtra w naglowkach kolumn = przycisk Primary FilledFilled (buttonColorMap)
    [ThemeVariableType.FilterActiveBackgroundColor]: variables[ThemeVariableType.PrimaryColor],
    [ThemeVariableType.FilterActiveBackgroundHoverColor]: variables[ThemeVariableType.PrimaryHoverColor],
    [ThemeVariableType.FilterActiveContentColor]: variables[ThemeVariableType.OnPrimaryColor],
    [ThemeVariableType.FilterActiveContentHoverColor]: variables[ThemeVariableType.OnPrimaryHoverColor],
  }
}
